import { createInstance as f } from "i18next";
import g from "i18next-browser-languagedetector";
import m from "./locales/en/translation.json.js";
import u from "./locales/es/translation.json.js";
import p from "./locales/pt/translation.json.js";
import L from "./locales/ca/translation.json.js";
import b from "./locales/pl/translation.json.js";
var l;
((n) => {
  n.fallbackLng = "en";
  const o = {
    en: {
      translation: m
    },
    es: {
      translation: u
    },
    pt: {
      translation: p
    },
    ca: {
      translation: L
    },
    pl: {
      translation: b
    }
  };
  function s(a) {
    const t = f();
    return t.use(g), a.forEach((r) => t.use(r)), t.init({
      debug: !1,
      fallbackLng: n.fallbackLng,
      interpolation: {
        escapeValue: !1
      },
      detection: {
        order: ["navigator"],
        caches: []
      },
      resources: o
    }), t;
  }
  n.createI18nInstance = s;
  function c(a, t) {
    const r = /* @__PURE__ */ new Set([
      ...t,
      // Native languages
      Object.keys(o)
    ]);
    for (let e = 0; e < a.length; e += 1) {
      const i = a[e];
      if (r.has(i))
        return i;
    }
    return a[0] || n.fallbackLng;
  }
  n.getPriorityLanguage = c;
})(l || (l = {}));
export {
  l as I18N
};
//# sourceMappingURL=index.js.map
